<div class="d-flex flex-column align-items-stretch wrapper mt-2 mb-1">
    <div class="d-flex align-items-center mb-3">
        <div *ngIf="icon || label" class="me-auto">
            <i class="icon {{icon}} me-2" *ngIf="icon"></i>
            <div *ngIf="label" class="font-large color-greyish">{{ label | translate}}</div>
        </div>
        <div *ngIf="!readonly" class="ms-auto font-large d-flex align-items-center">
            <i class="font-large me-2 pi pi-info-circle color-light-grey"></i>
            <span class="font-medium color-light-grey" translate>REPORTS.TEXT.EDIT</span>
        </div>

    </div>
    <div class="w-100" #textAreaRef>
        <div *ngIf="!refresh" class="w-100">
            <textarea rows="3" *ngIf="form && froala && froalaOptions && !readonly" [formControl]="form"
                [froalaEditor]="froalaOptions" (froalaInit)="initialize($event)" class="w-100"></textarea>
            <textarea rows="3" *ngIf="!form && froala && froalaOptions && !readonly" (froalaInit)="initialize($event)"
                [(froalaModel)]="model" [froalaEditor]="froalaOptions" class="w-100"></textarea>
            <textarea rows="3" *ngIf="!froala &&  !readonly" placeholder="{{placeholder | translate}}"
                [formControl]="form" class="w-100" [readonly]="readonly"></textarea>
            <div *ngIf="readonly && form" [innerHTML]="form?.value ? form?.value : '' | safeHtml" class="w-100 border-textarea"></div>
            <div *ngIf="readonly && !form" [innerHTML]="model | safeHtml" class="w-100 border-textarea"></div>
        </div>
        <!--<div *ngIf="!focus" class="text w-100" (click)="setFocus($event)">
            <span *ngIf="!form && !model || (form && !form.value)">
                {{ 'REPORTS.TEXT.EMPTY' | translate}}
            </span>
            <div *ngIf="form && form.value" [innerHTML]="form.value"></div>
            <div *ngIf="model" [innerHTML]="model"></div>
        </div>-->
    </div>
    <mapfre-auditlib-form-errors *ngIf="form" [form]="form" [targetRef]="textAreaRef"
        [skipHighlighter]="skipHighlighter"></mapfre-auditlib-form-errors>
</div>